<template>
  <div class="sector-rail">
    <h3 class="sector-rail-title">Explore by Sector</h3>
    <div class="sector-chips-container">
      <div class="sector-chips">
        <button
          class="sector-chip"
          :class="{ active: selectedSector === null }"
          @click="selectSector(null)"
        >
          All <span class="chip-count">({{ totalStocks }})</span>
        </button>
        <button
          v-for="sector in sectors"
          :key="sector.name"
          class="sector-chip"
          :class="{ active: selectedSector === sector.name }"
          @click="selectSector(sector.name)"
        >
          {{ sector.name }} <span class="chip-count">({{ sector.count }})</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  sectors: {
    type: Array,
    required: true
  },
  selectedSector: {
    type: String,
    default: null
  }
});

const emit = defineEmits(['sectorSelected']);

const totalStocks = computed(() => {
  return props.sectors.reduce((sum, sector) => sum + sector.count, 0);
});

const selectSector = (sectorName) => {
  emit('sectorSelected', sectorName);
};
</script>

<style scoped>
.sector-rail {
  margin-bottom: 16px;
}

.sector-rail-title {
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 10px 0;
  color: #1f2937;
}

.sector-chips-container {
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.sector-chips-container::-webkit-scrollbar {
  display: none;
}

.sector-chips {
  display: flex;
  gap: 6px;
  padding-bottom: 3px;
  min-width: min-content;
}

.sector-chip {
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 6px 10px;
  border: 1px solid #d1d5db;
  border-radius: 16px;
  background: #fff;
  color: #4b5563;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.sector-chip:hover {
  border-color: #3b82f6;
  color: #3b82f6;
  background: #eff6ff;
}

.sector-chip.active {
  background: #3b82f6;
  border-color: #3b82f6;
  color: #fff;
}

.chip-count {
  font-size: 0.7rem;
  opacity: 0.8;
  font-weight: 400;
}

@media (max-width: 768px) {
  .sector-chip {
    padding: 5px 8px;
    font-size: 0.75rem;
  }
}
</style>
